import React from 'react';

interface OwnProps {
    value?: string;
    name: string;
    onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

type Props = OwnProps;

interface IOwnState {
    labelText: string;
}

class FormNakedSelect extends React.Component<Props, IOwnState> {
    private select = React.createRef<HTMLSelectElement>();
    private label = React.createRef<HTMLLabelElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            labelText: ''
        };
    }

    public async componentDidMount() {
        this.setState({ labelText: this.select.current!.options[this.select.current!.selectedIndex].text });
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.value !== this.props.value) {
            this.setState({ labelText: this.select.current!.options[this.select.current!.selectedIndex].text });
        }
    }

    public focus = () => {
        this.select.current!.focus();
    }

    private handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        e.persist();

        this.setState({ labelText: this.select.current!.options[this.select.current!.selectedIndex].text });

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    public render() {
        return <div className="naked-select js--naked-select">
            <select name={this.props.name} value={this.props.value} onChange={this.handleChange} ref={this.select}>
                {this.props.children}
            </select>
            <label htmlFor={this.props.name} ref={this.label}>{this.state.labelText}</label>
        </div>
    }
}

export default FormNakedSelect;